import styled from 'styled-components'
import { BLUE } from '../../utils/colors'
import { MD } from '../../utils/screenSizes'

export const VerificationCode = styled.div`
  margin-top: 72px;
`

export const SocialButtons = styled.div`
  margin: 0 auto;
  margin-bottom: 42px;
  max-width: 345px;
`

export const Center = styled.div`
  max-width: 320px;
  width: 100%;
  margin: 0 auto;
  text-align: center;

  span {
    display: block;
    margin-top: -20px;
    font-family: Mont;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 32px;
  }
`

export const Container = styled.div`
  color: ${BLUE};
  max-width: 470px;

  .image {
    width: 100%;

    @media (max-width: ${MD}) {
      display: none;
    }
  }

  p {
    margin-bottom: 36px;
    font-family: Mont, sans-serif;
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;

    @media (max-width: ${MD}) {
      text-align: center;
      line-height: 1.33;
    }
  }

  h1 {
    @media (max-width: ${MD}) {
      font-size: 40px;
      line-height: 1.24;
      text-align: center;
      margin-right: -12px;
      margin-left: -12px;
      margin-bottom: 73px;
    }
  }

  b {
    font-weight: 700;
  }

  .buttons {
    margin: 0 auto;
    margin-top: 41px;
    max-width: 336px;
  }
`
